import { useMemo } from 'react';
import styled from 'foundations-theming/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { AVATAR_SOURCE_TYPES } from '../../Constants';
import { AvatarEditOverlay } from './AvatarEditOverlay';
import SocialBadge from './SocialBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContentHolder = styled.div.withConfig({
  displayName: "AvatarContentWrapper__ContentHolder",
  componentId: "sc-1hxz1cp-0"
})(["position:relative;display:flex;align-items:center;font-size:initial;background-size:cover;background-position:center;width:100%;aspect-ratio:1 / 1;border-radius:", ";overflow:hidden;", ";svg{fill:", " !important;color:", " !important;}"], ({
  $type
}) => $type === 'productId' ? '3px' : '50%', ({
  $cssStyles
}) => $cssStyles, ({
  $iconColor
}) => $iconColor, ({
  $iconColor
}) => $iconColor);
export const AvatarContentWrapper = ({
  children,
  backgroundColor,
  href,
  isEditable,
  iconColor,
  iconType,
  src,
  size,
  socialNetwork,
  type
}) => {
  const cssStyles = useMemo(() => {
    return {
      backgroundColor,
      backgroundImage: src ? `url(${src})` : 'none'
    };
  }, [backgroundColor, src]);
  const source = useMemo(() => {
    if (src) {
      return AVATAR_SOURCE_TYPES.KNOWN_SRC.toUpperCase();
    }
    if (iconType) {
      return `DEFAULT_${iconType}`;
    }
    return `UNKNOWN`;
  }, [src, iconType]);
  const dataTestIds = {
    'data-test-id': 'content-holder',
    'data-source': source,
    type
  };
  const avatarBadgeContent = useMemo(() => {
    if (socialNetwork) {
      return /*#__PURE__*/_jsx(SocialBadge, {
        socialNetwork: socialNetwork,
        size: size
      });
    }
    return null;
  }, [size, socialNetwork]);
  const avatarOverlay = useMemo(() => {
    if (isEditable) {
      return /*#__PURE__*/_jsx(AvatarEditOverlay, {});
    }
    return null;
  }, [isEditable]);
  if (href) {
    return /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "content-holder-link",
      use: "unstyled",
      href: href,
      display: "flex",
      blockSize: "100%",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(ContentHolder, Object.assign({}, dataTestIds, {
        $cssStyles: cssStyles,
        $iconColor: iconColor,
        $type: type,
        children: [children, avatarOverlay]
      })), socialNetwork ? /*#__PURE__*/_jsx(SocialBadge, {
        socialNetwork: socialNetwork,
        size: size
      }) : null]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ContentHolder, Object.assign({}, dataTestIds, {
      $cssStyles: cssStyles,
      $iconColor: iconColor,
      $type: type,
      children: [children, avatarOverlay]
    })), avatarBadgeContent]
  });
};